import { Component } from '@angular/core';
import { ShowComponent } from 'src/app/common/component/show.component';

@Component({
	selector: 'app-google-contacts',
	templateUrl: './google-contacts.component.html',
	styleUrls: ['./google-contacts.component.css'],
})
export class GoogleContactsComponent extends ShowComponent {
	protected parentComponent = 'googleContacts';
	protected apiUrlAdd = '/google/googleContacts';
	protected idType = 'auto';
	personId;
	contactTypes: Array<any> = [
		{
			id: 'work',
			name: 'Służbowy',
		},
		{
			id: 'private',
			name: 'Prywatny',
		},
	];
	workPlace: Array<any> = [
		{
			id: 'galeria_sucholeska',
			name: 'Galeria Sucholeska',
		},
		{
			id: 'rosarium',
			name: 'Rosarium',
		},
		{
			id: 'rumianek',
			name: 'Rumianek',
		},
	];
	occupationTypes: Array<any> = [
		{
			id: 'antenna',
			name: 'Antenka',
		},
		{
			id: 'coach',
			name: 'Autokar',
		},
		{
			id: 'coach&tir',
			name: 'Autokar&TIR',
		},
		{
			id: 'office',
			name: 'Biuro',
		},
		{
			id: 'guide',
			name: 'Pilot',
		},
		{
			id: 'resident',
			name: 'Rezydent',
		},
		{
			id: 'jumper',
			name: 'Skoczek',
		},
		{
			id: 'tir',
			name: 'TIR',
		},
		{
			id: 'workshop',
			name: 'Warsztat',
		},
	];
	departaments: Array<any> = [];
	company: Array<any> = [];
	employerList: Array<any> = [];
	statuses: Array<any> = [];
	data = {
		id: null,
		resourceName: null,
		etag: null,
		givenName: null,
		familyName: null,
		occupation: null,
		birthday: null,
		numberWork: null,
		numberPrivate: null,
		mailWork: null,
		mailPrivate: null,
		organizationJob: null,
		workPlace: null,
		city: null,
		idUsers: null,
		status: null,
	};

	protected getApiUrl(): string {
		return '/google/googleContacts/' + this.data.id;
	}

	protected loadBefore() {
		this.api.get('/departaments/', (result) => {
			this.departaments = result.data;
			this.loadData();
		});
		this.api.get('/company/', (result) => {
			this.company = result.data;
			this.loadData();
		});
		this.api.get('/employerList/', (result) => {
			this.employerList = result.data;
			this.loadData();
		});
		this.api.get('/driverStatus/', (result) => {
			this.statuses = result.data;
			this.loadData();
		});
	}
	driverKinds: Array<any> = [
		{ id: '1', name: 'Antenka' },
		{ id: '2', name: 'Autokar' },
		{ id: '3', name: 'Autokar&Tir' },
		{ id: '4', name: 'TIR' },
		{ id: 'office', name: 'Biuro' },
		{ id: 'guide', name: 'Pilot' },
	];
	protected onChange(deviceValue) {
		if (deviceValue === undefined) {
			this.data.familyName = null;
			this.data.givenName = null;
			this.data.occupation = null;
			this.data.status = null;
			return;
		}
		const choosen_person = this.employerList.find((driver) => this.personId === driver.id);
		this.data.familyName = choosen_person.lastName;
		this.data.givenName = choosen_person.firstName;
		this.data.occupation = choosen_person.profile;

		const findKinds = this.driverKinds.find((findObj) => findObj.id === choosen_person.driverKind);
		this.data.occupation = findKinds === undefined ? null : findKinds.name;
		this.data.occupation = findKinds ? findKinds.name : null;
	}
}
